import { createApi } from '@reduxjs/toolkit/query/react';

import { createBaseQuery } from '../../common/api/createBaseQuery';
import { IAppContext } from '../../common/types/applicationContext';
import {
  fetchPublicB2cV1GetOffers,
  TPublicB2cV1GetOffersRequest,
  TPublicB2cV1GetOffersResponse_1,
} from '../../common/repositories/mortgage-broker-calculator/b2c/v1/get-offers';

export type TMortgageMiniCalculatorApiEndpoints = keyof typeof mortgageMiniCalculatorApi.endpoints;
export let mortgageMiniCalculatorApi: ReturnType<typeof createMortgageMiniCalculatorApi>;

export const createMortgageMiniCalculatorApi = (ctx: IAppContext) => {
  const newApi = createApi({
    reducerPath: 'mortgageMiniCalculatorApi',
    baseQuery: createBaseQuery(ctx),
    endpoints: builder => ({
      getOffers: builder.query<TPublicB2cV1GetOffersResponse_1, TPublicB2cV1GetOffersRequest>({
        query: parameters => ({
          parameters,
          fetchFunction: fetchPublicB2cV1GetOffers,
          loggerInfo: {
            description: 'Получение оферов для мини калькулятора',
            degradation: 'Отображение критической ошибки, листинг недоступен',
          },
        }),
      }),
    }),
  });

  mortgageMiniCalculatorApi = newApi;

  return newApi;
};
